import { FC, Suspense, lazy, useEffect } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_metronic/assets/ts/_utils";
import { WithChildren } from "../../_metronic/helpers";
import { MasterLayout } from "../../_metronic/layout/MasterLayout";
import { localStorageItem } from "../../app/modules/utils/LocalStorage";
import { HomePage } from "../pages/Homepage/HomePage";
import { MenuTestPage } from "../pages/MenuTestPage";
import { DashboardWrapper } from "../pages/dashboard/DashboardWrapper";
import MakeAnAppointmentPage from "../modules/make-an-appointment/MakeAnAppointmentPage";
import OrganizationPage from "../modules/organization/OrganizationPage";
import ConnectPage from "../modules/connect/ConnectPage";
import ServicePage from "../modules/services/ServicePage";
import ParaclinicalPage from "../modules/paraclinical/ParaclinicalPage";
import LogPage from "../modules/log/LogPage";
import LogPatientPage from "../modules/log-benh-nhan/LogPatientPage"; 

const PrivateRoutes = () => {
  const navigate = useNavigate();
  const WizardsPage = lazy(() => import("../modules/wizards/WizardsPage"));
  const AccountPage = lazy(() => import("../modules/accounts/AccountPage"));
  const listMenu = localStorageItem.get("id-token-decode")?.menus?.["oceantech-wms-server"]
  useEffect(() => {
    if (!listMenu?.[0]?.subs?.length) {
      navigate("/error/403");
    } else {
      // navigate(`${listMenu?.[0]?.subs?.[0]?.uri}`);
    }
  }, [listMenu?.[0]?.subs?.length])
  return (
    <Routes>
      <Route index element={<Navigate to={`organization`} />} />
      <Route path="/*" element={<Navigate to={`${listMenu?.[0]?.subs?.[0]?.uri}`} />} />
      {/* <Route index element={<Navigate to="/home" />} />
      <Route path="/*" element={<HomePage />} /> */}

      <Route path="home" element={<HomePage />} />
      <Route element={<MasterLayout />}>
        <Route path="auth/*" element={<Navigate to="/home" />} />
        <Route path="dashboard" element={<DashboardWrapper />} />
        <Route path="menu-test" element={<MenuTestPage />} />
        {/* {
          listMenu[0]?.subs.map((item?: any, index?: any) => {
            // const DataComponent = item?.component
            return <Route path={item?.uri} element={<PhanHeVienPhi />} />
          })
        } */}
        <Route path="make-an-appointment" element={<MakeAnAppointmentPage />} />
        <Route path="organization" element={<OrganizationPage />} />
        <Route path="connect" element={<ConnectPage />} />
        <Route path="service" element={<ServicePage />} />
        <Route path="paraclinical" element={<ParaclinicalPage />} />
        <Route path="log" element={<LogPage />} />
        <Route path="patient-log" element={<LogPatientPage />} />
        {/* Lazy Modules */}
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route path="crafted/pages/profile/*" element={<SuspensedView></SuspensedView>} />
        <Route
          path="crafted/pages/wizards/*"
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path="crafted/account/*"
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>

  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue("--kt-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };

